(function () {
  angular.module("akitabox.ui.directives.accountAutocomplete", [
    "akitabox.core.services.identity",
    "akitabox.core.toast",
  ]);
})();
